<template>
	<div class="p_m_t_30">
		<div class="p_flex p_f_a p_f_b type_size_20">
			<span class="">成绩概况</span>
			<div class="p_flex p_f_a">
				<el-button style="margin-right: 10px" @click='wrongTopic()'
						   type="success" size="mini">线下分发错题
				</el-button>
				<span class="subject_yellow">{{ submit_rate_defno }}人未提交</span>
				<span class="subject_color p_m_l_20 small_hand" @click="goGeneral">查看详情</span>
			</div>
		</div>
		<div class="p_m_t_30 p_flex">
			<div class="p_m_r_60">
				<div class="general_box">
					<el-progress type="circle" :width="width"
								 :percentage="parseFloat(exact_rate_def)?parseFloat(exact_rate_def):0"
								 :show-text="false" color="#00AF63" status="success"></el-progress>
					<div class="general_cneter subject_color">
						<div class="type_size_20 type_cneter p_m_b_20">{{ exact_rate_def }}%</div>
						<span>平均正确率</span>
					</div>
				</div>
				<div class="type_size_16 type_cneter p_m_t_30">
					<div>最高100%</div>
					<div class="p_m_t_14">学生最低{{ failoercentage }}%</div>
				</div>
			</div>
			<div class="p_flex general_cneters p_m_l_60">
				<div class="general_box p_m_r_30">
					<el-progress type="circle" :width="widths"
								 :percentage="parseFloat(excellentpercentage)?parseFloat(excellentpercentage):0"
								 :show-text="false" color="#00AF63" status="success"></el-progress>
					<div class="general_cneter subject_color">
						<div class="type_size_20 type_cneter p_m_b_20">{{ excellentnumber ? excellentnumber : 0 }}</div>
						<span>优秀</span>
					</div>
				</div>
				<div class="general_box p_m_l_30">
					<el-progress type="circle" :width="widths"
								 :percentage="parseFloat(goodpercentage)?parseFloat(goodpercentage):0"
								 :show-text="false" color="#FBB13C" status="success"></el-progress>
					<div class="general_cneter subject_yellow">
						<div class="type_size_20 type_cneter p_m_b_20">{{ goodnumber ? goodnumber : 0 }}</div>
						<span>良好</span>
					</div>
				</div>
				<div class="general_box p_m_r_30 p_m_t_14">
					<el-progress type="circle" :width="widths"
								 :percentage="parseFloat(qualifiedpercentage)?parseFloat(qualifiedpercentage):0"
								 :show-text="false" color="#3785FC" status="success"></el-progress>
					<div class="general_cneter subject_blue">
						<div class="type_size_20 type_cneter p_m_b_20">{{ qualifiednumber ? qualifiednumber : 0 }}</div>
						<span>及格</span>
					</div>
				</div>
				<div class="general_box p_m_l_30 p_m_t_14">
					<el-progress type="circle" :width="widths"
								 :percentage="parseFloat(failoercentage)?parseFloat(failoercentage):0"
								 :show-text="false" color="#FF51A8" status="success"></el-progress>
					<div class="general_cneter subject_pink">
						<div class="type_size_20 type_cneter p_m_b_20">{{ failnumber ? failnumber : 0 }}</div>
						<span>不及格</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		ids: String
	},
	data() {
		return {
			width: 160,
			widths: 120,
			exact_rate_def: "",   //平均正确率
			submit_rate_defno: "",  //未提交人数
			excellentnumber: "",   //优秀人数
			excellentpercentage: "",  //优秀百分比
			goodnumber: "",   // 良好人数
			goodpercentage: "", //良好百分比
			qualifiednumber: "", //及格人数
			qualifiedpercentage: "",//及格百分比
			failnumber: "", //不及格人数
			failoercentage: "", //不及格百分比
			teachid:''//老师id
		};
	},
	mounted() {
	},
	created() {
		this.$request.ajax(this).post("/api_teacher/analysis_report", {
			job_publish_id: this.ids
		}).then(res => {
			// console.log(res)
			this.exact_rate_def = res.data.exact_rate_def   //平均正确率
			this.submit_rate_defno = res.data.submit_rate_def.no   //未提交人数
			this.excellentnumber = res.data.summary.excellent.number  //优秀人数
			this.excellentpercentage = res.data.summary.excellent.percentage   //优秀百分比
			this.goodnumber = res.data.summary.good.number  //良好人数
			this.goodpercentage = res.data.summary.good.percentage   //良好百分比
			this.qualifiednumber = res.data.summary.qualified.number  //及格人数
			this.qualifiedpercentage = res.data.summary.qualified.percentage  //及格百分比
			this.failnumber = res.data.summary.fail.number  //不及格人数
			this.failoercentage = res.data.summary.fail.percentage   //不及格百分比
			this.teachid=res.data.teacher_id
		})
	},
	methods: {
		goGeneral() {
			this.$router.push({
				path: 'AnalyseGeneral',
				query: {
					id: this.ids
				}
			});
		},
		//线下分发错题
		wrongTopic() {
			let data = {}
			data.teachid = this.teachid
			data.jobpublishid = this.ids
			data.type = 2
			data.img_path = ''
			data.create_time = null
			data.status = 0
			this.$request.ajax(this).post('/api_teacher/readytodo_create', data).then((res) => {
				if (res.msg = 'success') {
					this.$message({
						message: '分发成功！',
						type: 'success'
					})
				} else {
					this.$message({
						message: '分发失败！',
						type: 'error'
					})
				}
			})
		},
	}
};
</script>

<style lang="scss" scoped>
.general_box {
	position: relative;
}

.general_cneter {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.type_cneter {
	text-align: center;
}

.general_cneters {
	flex-wrap: wrap;
}

.subject_blue {
	color: #3785FC;
}

.subject_pink {
	color: #FF51A8;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/deatilgeneral.vue